import { CampaignSettingScrollspy } from "./CampaignSettingScrollspy";

export { CampaignSettingScrollspy };
export default CampaignSettingScrollspy;
